module.exports = __webpack_public_path__ + "img/211.24740f6c.jpg";